module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Server-09731cb78c67738c0e7467647b23523b.svg";